import { Routes } from '@angular/router'

import { DefaultApplicationPermissionsGuard } from '@flowx/designer/shared/guards/application-permissions.guards'
import { EditProcessInstanceVariablesGuard } from '@flowx/designer/shared/guards/workspaces-permissions.guards'
import { LayoutOptions } from '@flowx/designer/shared/types/layout.types'

import { ProcessInstancePageComponent } from './pages/process-running-instance/process-running-instance.page'

export const RuntimeProcessInstanceRoutes: Routes = [
  {
    path: ':selectedProcessResourceId/instance',
    component: ProcessInstancePageComponent,
    canActivate: [
      DefaultApplicationPermissionsGuard('process_instances_read'),
      EditProcessInstanceVariablesGuard(),
    ],
    data: {
      [LayoutOptions.IS_RUNNING_INSTANCE]: true,
    },
  },
]
